import { observable } from "mobx";
import { Type } from "class-transformer";
import CardAssociationType from "./cardAssociationType";
import DomesticBankAccountResponse from "./domesticBankAccountResponse";
import TerminalType from "./terminalType";
import TransactionType from "./transactionType";
import CardGatewayPaymentClassificationResponse from "./cardGatewayPaymentClassificationResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class CardGatewayPaymentDetailResponse {
  /**
   * Payment ID.
   */
  id!: string;

  @observable
  @Type(() => DomesticBankAccountResponse)
  bankAccount!: DomesticBankAccountResponse;

  @observable
  @Type(() => CardGatewayPaymentClassificationResponse)
  paymentClassification!: CardGatewayPaymentClassificationResponse;

  /**
   * Variable symbol.
   */
  @observable
  variableSymbol?: number;

  /**
   * Brutto amount.
   */
  @observable
  bruttoAmount!: number;

  /**
   * Netto amount.
   */
  @observable
  nettoAmount!: number;

  /**
   * Authorized at.
   */
  @observable
  @Type(() => Date)
  authorizedAt!: Date;

  @observable
  transactionType!: TransactionType;

  /**
   * Interchange fee.
   */
  @observable
  interchangeFee!: number;

  /**
   * Acquirer fee.
   */
  @observable
  acquirerFee!: number;

  /**
   * Commission fee.
   */
  @observable
  commissionFee!: number;

  @observable
  terminalType!: TerminalType;

  /**
   * Terminal ID.
   */
  @observable
  terminalId!: string;

  /**
   * Auth code.
   */
  @observable
  authCode!: string;

  /**
   * Merchant ID.
   */
  @observable
  merchantId!: string;

  /**
   * Arn.
   */
  @observable
  arn!: string;

  /**
   * Payment ident.
   */
  @observable
  paymentIdent?: string;

  /**
   * Invoice number.
   */
  @observable
  invoiceNumber!: string;

  /**
   * Transfer variable symbol.
   */
  @observable
  transferVariableSymbol!: number;

  /**
   * Transfer specific symbol.
   */
  @observable
  transferSpecificSymbol!: number;

  @observable
  cardAssociation!: CardAssociationType;

  /**
   * Card number.
   */
  @observable
  cardNumber!: string;

  /**
   * Statement date.
   */
  @observable
  @Type(() => Date)
  statementDate!: Date;

  /**
   * Created at.
   */
  @observable
  @Type(() => Date)
  createdAt!: Date;
}
